module.exports = __webpack_public_path__ + "static/media/brokenImage.c18d829a.svg";